export default "__VITE_ASSET__C_5$aLTB__"